export default __webpack_public_path__ + "static/media/Dazzed-SemiBold.c77887d0.woff2";